var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"al"},[_c('van-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.show = true}}},[_vm._v("滑块")]),_c('van-popup',{on:{"opened":_vm.opened},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{attrs:{"id":"slider"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }